/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from "react";
import {Provider} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import {PersistGate} from "redux-persist/integration/react";
import {Routes} from "./app/router/Routes";
import I18nProvider from "./app/providers/I18nProvider";
import FullPageLoadingModal from "./components/ui/FullPageLoadingModal";
import WebSocketProvider from "./app/components/WebSocketProvider";
import GlobalNotificationHandler from "./app/components/ui/GlobalNotificationHandler";
import DevToolbar from "./app/components/DevToolbar";
import { ChatProvider } from "./app/contexts/ChatContext";

function AppContent() {
  return (
    <>
      {/* Global notification handler for permission errors */}
      <GlobalNotificationHandler />
      {/* Render routes with provided `Layout`. */}
      <Routes />
      {/* Dev tools - only renders when production is false */}
      <DevToolbar />
    </>
  );
}

export default function App({store, persistor, basename}) {
  return (
    /* Provide Redux store */
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      <PersistGate persistor={persistor} loading={<FullPageLoadingModal />}>
        {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
        <React.Suspense fallback={<FullPageLoadingModal />}>
          {/* Override `basename` (e.g: `homepage` in `package.json`) */}
          <BrowserRouter basename={basename}>
            {/* Provide `react-intl` context for translations. */}
            <I18nProvider>
              <WebSocketProvider>
                {/* Provide Chat context for global chatbot state */}
                <ChatProvider>
                  <AppContent />
                </ChatProvider>
              </WebSocketProvider>
            </I18nProvider>
          </BrowserRouter>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}
